import { useNavigate } from "@tanstack/react-router"

import { scale } from "@productlane/lib/src/plans-client"

import { toast } from "@/components/toast"
import { useRequiredPlans } from "@/lib/plans"

export const NEW_PORTAL_PATH = "/settings/portal/instances/new"

/** Opens the new-portal form, or explains the Scale gate instead. */
export function useOpenNewPortal() {
	const navigate = useNavigate()
	const { passes, initialized } = useRequiredPlans(scale.andUp)

	return () => {
		// Until the plan loads, the form itself gates on it.
		if (initialized && !passes) {
			toast.info({
				title: "Multiple portals need the Scale plan",
				description: "Upgrade to run more than one portal on your domain.",
				action: {
					label: "View plans",
					callback: () => void navigate({ to: "/settings/plans" }),
				},
			})
			return
		}
		void navigate({ href: NEW_PORTAL_PATH })
	}
}
